import ToolBar from "../../Components/ToolBar/ToolBar";
import { toast } from "react-toastify";
import { useContext, useState, useRef, useEffect } from "react";
import AppContext from "../../Context/AppContext";
import {
  RestSkuBatchInventoryListRequest,
  DailyInventoryTrackInquiryCriteriaBean,
  PageListBean,
  BatchInventorySummaryDataPrintRequest,
  RestSKUBatchInventoryTrackListRequest,
  FabricStyleSearchCriteria,
  RestFabricStyleListRequest,
  RestReadRequest,
  DailyInventoryProcessTrackInquiryCriteriaBean,
} from "../../Ds/ds";
import SelectOption from "../../Components/Base/SelectOption";
import { RestReportBean } from "../../Ds/client_ds";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  ColumnDefinition,
  getSuggestions,
} from "../../Utils/util";
import PageBar from "../../Components/ToolBar/PageBar";
import Loader from "../../Components/Loder";
import InputTextBox from "../../Components/Base/InputTextBox";
import CustomButton from "../../Components/Base/CustomButton";
import service from "../../Services/Service";
import {
  TOAST_ERROR,
  TOAST_SUCESS,
  TOAST_THEME_COLOR,
  TOAST_WARN,
} from "../../Utils/appConstants";
import InValidAccess from "../../Components/InValidAccess";
import { SecurityAccessManager } from "../../Security/SecurityAccessManager";
import NoData from "../../Components/NoData";
import CustomTable from "../../Components/Base/CustomTable";
import ViewToggle from "../../Components/ViewToggle";
import Modal from "../../Components/Modal";
import AutoComplete from "../../Components/Base/AutoComplete";
import Date_Picker from "../../Components/Base/DatePicker";
export default function DailyInventoryTrackHistoryInquiry() {
  const title = "Daily Inventory Track";
  const { token, setisSessionExpeired, session } = useContext(AppContext);
  const [view, setView] = useState(window.innerWidth <= 768 ? 1 : 2);
  const [code, setCode] = useState("");

  const [criteria, setCriteria] = useState(
    new DailyInventoryTrackInquiryCriteriaBean()
  );
  const [suggestions, setSuggestions] = useState([]);
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowPdf, setIsShowPdf] = useState(false);
  const [isShowExcel, setIsShowExcel] = useState(false);
  const [disable, setDisable] = useState(false);
  const [isAccessible, setIsAccessible] = useState(false);

  const [inventoryList, setInventoryList] = useState([]);
  const [inventoryProcessList, setInventoryProcessList] = useState([]);

  const [isShowReceivedQtyModalLvl1, setIsShowReceivedQtyModalLvl1] =
    useState(false);
  const [isShowAdjustedQtyModalLvl1, setIsShowAdjustedQtyModalLvl1] =
    useState(false);
  const [isShowShippedQtyModalLvl1, setIsShowShippedQtyModalLvl1] =
    useState(false);

  const [isShowReceivedQtyModalLvl2, setIsShowReceivedQtyModalLvl2] =
    useState(false);
  const [isShowAdjustedQtyModalLvl2, setIsShowAdjustedQtyModalLvl2] =
    useState(false);
  const [isShowShippedQtyModalLvl2, setIsShowShippedQtyModalLvl2] =
    useState(false);

  const [receivedQtyList, setReceivedQtyList] = useState([]);
  const [adjustedQtyList, setAdjustedQtyList] = useState([]);
  const [shippedQtyList, setShippedQtyList] = useState([]);

  const [receivedInventoryQtyList, setReceivedInventoryQtyList] = useState([]);
  const [adjustedInventoryQtyList, setAdjustedInventoryQtyList] = useState([]);
  const [shippedInventoryQtyList, setShippedInventoryQtyList] = useState([]);

  const [isShowEntityModal, setIsShowEntityModal] = useState(false);
  const [entityData, setEntityData] = useState(null);

  const [items, setItems] = useState([]);
  const inputRef = useRef(null);
  const buttonRef = useRef(null);
  useEffect(() => {
    function handleResize() {
      setView(getDefaultView());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  function getDefaultView() {
    return window.innerWidth <= 768 ? 1 : 2;
  }
  const setFocus = () => {
    if (inputRef.current != null) inputRef.current.focus();
  };
  useEffect(() => {
    setFocus();
    getItemList();
  }, []);
  const handleGetItemListResponse = (response) => {
    // console.log("Response item", response);
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.fabricStylePageList) &&
          !isEmptyArray(response.data.fabricStylePageList.fabricStyles)
        ) {
          const _list = new Array();
          response.data.fabricStylePageList.fabricStyles.map((ln) => {
            _list.push(ln.code);
          });
          setItems(_list);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };

  const getItemList = () => {
    if (SecurityAccessManager.ItemMaintenanceView_IsAccessible()) {
      const request = new RestFabricStyleListRequest();
      const _criteria = new FabricStyleSearchCriteria();
      _criteria.companyCode = process.env.REACT_APP_COMPANY;
      if (!isEmpty(session)) {
        const { entityCode, code } = session;
        if (!isEmptyString(entityCode))
          _criteria.logisticCustomerCode = entityCode;
        if (!isEmptyString(code)) _criteria.customerUserCode = code;
      }
      const pageInput = new PageListBean();
      // pageInput.currentPage = 1;
      // pageInput.pageSize = pageSize;

      request.searchCriteria = _criteria;
      request.pageInput = pageInput;

      const path = "getItemListBasedOnCustomer";
      service(token, path, request, handleGetItemListResponse, errorCallBack);
    } else {
      setIsAccessible(true);
    }
  };
  const handleReportResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (response.data != null) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (response.data.reportResult != null) {
          if (!isEmptyString(response.data.reportResult.reportFileID)) {
            let reportFilePath = response.data.reportResult.reportFileID;
            window.open(
              `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_REPORT_PATH}` +
                reportFilePath
            );
          }
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => {
            msg_List.push(info.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_SUCESS, msg);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };
  const generateReport = (type) => {
    // const criteria = new DailyInventoryTrackInquiryCriteriaBean();
    // criteria.fabricStyleCode = code;
    criteria.companyCode = process.env.REACT_APP_COMPANY;
    if (!isEmpty(session)) {
      const { entityCode, code } = session;
      if (!isEmptyString(entityCode))
        criteria.logisticCustomerCode = entityCode;
      if (!isEmptyString(code)) criteria.customerUserCode = code;
    }
    const reportBean = new RestReportBean();
    reportBean.reportType = type;
    const request = new RestSKUBatchInventoryTrackListRequest();
    request.searchCriteria = criteria;
    request.reportBean = reportBean;
    const path = "generateRollingInventoriesDetailsPrintReport";
    service(token, path, request, handleReportResponse, errorCallBack);
  };
  const PDFHandler = () => {
    // if (
    //   SecurityAccessManager.SkuBatchInventoryInquiryPDFReport_IsAccessible()
    // ) {
    setIsLoading(true);
    // generateReport(1);
    // } else {
    //   setIsAccessible(true);
    // }
  };
  const ExcelHandler = () => {
    // if (
    //   SecurityAccessManager.SkuBatchInventoryInquiryExcelReport_IsAccessible()
    // ) {
    setIsLoading(true);
    // generateReport(2);
    // } else {
    //   setIsAccessible(true);
    // }
  };
  const ResetHandler = () => {
    setCode("");
    setInventoryList([]);
    setDisable(false);
    setIsShowExcel(false);
    setIsShowPdf(false);
    setFocus();
    setCriteria(new DailyInventoryTrackInquiryCriteriaBean());
  };
  const ExecuteHandler = () => {
    loadPage(1);
  };
  const notify = (type, msg, theme) => {
    if (type === 1)
      toast.info(msg, {
        theme: theme,
      });
    else if (type === 2)
      toast.error(msg, {
        theme: theme,
      });
    else if (type === 3)
      toast.success(msg, {
        theme: theme,
      });
    else if (type === 4)
      toast.warn(msg, {
        theme: theme,
      });
    else toast(msg);
  };
  const errorCallBack = (error) => {
    setIsLoading(false);
    notify(TOAST_ERROR, error.message);
  };
  const handleResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.resultBean) &&
          !isEmptyArray(response.data.resultBean.infos)
        ) {
          setInventoryList(response.data.resultBean.infos);
          setIsShowExcel(true);
          setIsShowPdf(true);
          loadInventoryProcessTrackPage();
        }
        if (
          !isEmpty(response.data.resultBean) &&
          isEmptyArray(response.data.resultBean.infos)
        ) {
          notify(TOAST_WARN, "No Data Found");
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => {
            msg_List.push(info.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_SUCESS, msg);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };
  const loadPage = (id) => {
    // if (SecurityAccessManager.SkuBatchInventoryInquiry_IsAccessible()) {
    setInventoryList([]);
    setIsLoading(true);
    criteria.companyCode = process.env.REACT_APP_COMPANY;
    criteria.locationCode = "WH1";
    if (!isEmpty(session)) {
      const { entityCode, code } = session;
      if (!isEmptyString(entityCode)) criteria.customerCode = entityCode;
    }

    const path = "inquireDailyInventoryTrackDetails ";
    service(token, path, criteria, handleResponse, errorCallBack);
    // } else {
    //   setIsAccessible(true);
    // }
  };
  const loadFirst = () => {
    loadPage(1);
  };
  const loadPrevious = () => {
    if (page > 1) {
      const pagenumber = parseInt(page) - 1;
      loadPage(pagenumber);
    }
  };
  const loadNext = () => {
    if (maxPage > page) {
      const pagenumber = parseInt(page) + 1;
      loadPage(pagenumber);
    }
  };
  const loadLast = () => {
    loadPage(maxPage);
  };
  const enterKeyHandler = (e) => {
    loadFirst();
  };
  const onChange = (e) => {
    // const criteria = new DailyInventoryTrackInquiryCriteriaBean();
    // if (e.target.name == "fabricStyleCode"){
    // criteria[e.target.name] = e.target.value.toUpperCase();
    // }
    criteria[e.target.name] = e.target.value;
    setCriteria(criteria);
    setSuggestions(getSuggestions(items, e.target.value));
  };
  const dateOnChange = (e) => {
    setCriteria((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };
  const onChange_ = (e) => {
    const { name, value, type, checked } = e.target;
    const inputValue = type === "checkbox" ? checked : value;
    setCriteria((prevState) => ({
      ...prevState,
      [name]:
        type === "number" ? parseFloat(inputValue).toFixed(2) : inputValue,
    }));
    setSuggestions(getSuggestions(items, value));
  };
  const handleReadResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.fabricStyle)) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        setCriteria(criteria);
        setSuggestions([]);
      }
    }
  };
  const readItemCode = (code) => {
    const path = "readFabricStyle";
    const request = new RestReadRequest();
    request.companyCode = process.env.REACT_APP_COMPANY;
    request.code = code;
    request.isLoadChildren = true;

    service(token, path, request, handleReadResponse, errorCallBack);
  };
  const clickHandler = (e) => {
    let itemCode = e.target.value;
    readItemCode(itemCode);
  };
  const buttonHandler = (e) => {
    loadFirst();
  };
  const listViewHandler = () => {
    setView(1);
  };
  const gridViewHandler = () => {
    setView(2);
  };
  const onClose = () => {
    setIsAccessible(false);
  };
  const closeModal = () => {
    setIsShowReceivedQtyModalLvl1(false);
    setIsShowAdjustedQtyModalLvl1(false);
    setIsShowShippedQtyModalLvl1(false);
    setIsShowEntityModal(false);
  };
  const closeModalLvl2 = () => {
    setIsShowReceivedQtyModalLvl2(false);
    setIsShowAdjustedQtyModalLvl2(false);
    setIsShowShippedQtyModalLvl2(false);
    setIsShowEntityModal(false);
  };

  const entityClickHanlder = (e, val, rowData) => {
    setIsShowEntityModal(true);
    setEntityData(rowData);
    getEntityDetails(rowData);
  };
  const getEntityDetails = () => {
    //
  };
  /*************************** Received Qty Popup[Lvl1]*****************************/

  const loadReceivedQtyPage = (data) => {
    alert("");
    let criteria = new DailyInventoryTrackInquiryCriteriaBean();
    criteria.companyCode = process.env.REACT_APP_COMPANY;
    criteria.entityType = data.updateEntityType;
    criteria.entityCode = data.updateEntityCode;
    criteria.fabricStyleCode = data.fabricStyleCode;
    criteria.fabricStyleColorCode = data.fabricStyleColorCode;
    criteria.locationCode = data.locationCode;

    setIsShowReceivedQtyModalLvl1(true);
    setIsLoading(true);
    const path = "getDailyInventoryReceivedDetails";
    service(token, path, criteria, loadReceivedQtyPageResponse, errorCallBack);
  };

  const loadReceivedQtyPageResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.resultBean) &&
          !isEmptyArray(response.data.resultBean.infos)
        ) {
          const list = new Array();
          const result = response.data.resultBean.infos;
          result.map((ln) => {
            list.push(ln);
          });
          setReceivedQtyList(list);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          setIsShowReceivedQtyModalLvl1(false);
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };
  /*************************** Adjusted Qty Popup[Lvl1]*****************************/

  const loadAdjustedQtyPage = (data) => {
    let criteria = new DailyInventoryTrackInquiryCriteriaBean();
    criteria.companyCode = process.env.REACT_APP_COMPANY;
    criteria.entityType = data.updateEntityType;
    criteria.entityCode = data.updateEntityCode;
    criteria.fabricStyleCode = data.fabricStyleCode;
    criteria.fabricStyleColorCode = data.fabricStyleColorCode;
    criteria.locationCode = data.locationCode;
    setIsShowAdjustedQtyModalLvl1(true);
    setIsLoading(true);
    // if (SecurityAccessManager.SkuBatchInventoryInquiry_IsAccessible()) {

    const path = "getDailyInventoryAdjustedDetails";
    service(token, path, criteria, loadAdjustedQtyPageResponse, errorCallBack);
    // } else {
    //   this.inValidAccess(1);
    // }
    // }
  };

  const loadAdjustedQtyPageResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.resultBean) &&
          !isEmptyArray(response.data.resultBean.infos)
        ) {
          const list = new Array();
          const result = response.data.resultBean.infos;
          result.map((ln) => {
            list.push(ln);
          });
          setAdjustedQtyList(list);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          setIsShowAdjustedQtyModalLvl1(false);
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };

  /*************************** Shipped Qty Popup[Lvl1]*****************************/

  const loadShippedQtyPage = (data) => {
    let criteria = new DailyInventoryTrackInquiryCriteriaBean();
    criteria.companyCode = process.env.REACT_APP_COMPANY;
    criteria.entityType = data.updateEntityType;
    criteria.entityCode = data.updateEntityCode;
    criteria.fabricStyleCode = data.fabricStyleCode;
    criteria.fabricStyleColorCode = data.fabricStyleColorCode;
    criteria.locationCode = data.locationCode;
    setIsShowShippedQtyModalLvl1(true);
    setIsLoading(true);
    const path = "getDailyInventoryShippedDetails";
    service(token, path, criteria, loadShippedQtyPageResponse, errorCallBack);
  };

  const loadShippedQtyPageResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.resultBean) &&
          !isEmptyArray(response.data.resultBean.infos)
        ) {
          const list = new Array();
          const result = response.data.resultBean.infos;
          result.map((ln) => {
            list.push(ln);
          });
          setShippedQtyList(list);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          setIsShowShippedQtyModalLvl1(false);
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };
  const loadInventoryProcessTrackPage = () => {
    let _criteria = criteria;
    let __criteria = new DailyInventoryProcessTrackInquiryCriteriaBean();
    __criteria.companyCode = process.env.REACT_APP_COMPANY;
    __criteria.fabricStyleCode = _criteria.fabricStyleCode;
    __criteria.fabricStyleColorCode = _criteria.fabricStyleColorCode;
    __criteria.customerCode = _criteria.customerCode;
    __criteria.locationCode = _criteria.locationCode;

    setIsLoading(true);
    const path = "inquireDailyInventoryProcessTrackDetails";
    service(
      token,
      path,
      __criteria,
      loadInventoryProcessPageResponse,
      errorCallBack
    );
  };

  const loadInventoryProcessPageResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.resultBean) &&
          !isEmptyArray(response.data.resultBean.infos)
        ) {
          const list = new Array();
          const result = response.data.resultBean.infos;
          result.map((ln) => {
            list.push(ln);
          });
          setInventoryProcessList(list);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };
  /*************************** Received Inventory Qty Popup[Lvl2]*****************************/

  const loadInventoryQtyPage = (data) => {
    let inventoryList = inventoryProcessList;

    let receivedList = inventoryList.filter(
      (ln) =>
        data.updateEntityCode == ln.updateEntityCode &&
        data.fabricStyleCode == ln.fabricStyleCode &&
        data.fabricStyleColorCode == ln.fabricStyleColorCode &&
        data.locationCode == ln.locationCode
    );

    if (!isEmpty(data.receivedQuantity)) {
      setIsShowReceivedQtyModalLvl2(true);
      setIsShowAdjustedQtyModalLvl2(false);
      setIsShowShippedQtyModalLvl2(false);
      setReceivedInventoryQtyList(receivedList);
    } else if (!isEmpty(data.adjustedQuantity)) {
      setIsShowReceivedQtyModalLvl2(false);
      setIsShowAdjustedQtyModalLvl2(true);
      setIsShowShippedQtyModalLvl2(false);
      setAdjustedInventoryQtyList(receivedList);
    } else if (!isEmpty(data.shippedQuantity)) {
      setIsShowReceivedQtyModalLvl2(false);
      setIsShowAdjustedQtyModalLvl2(false);
      setIsShowShippedQtyModalLvl2(true);
      setShippedInventoryQtyList(receivedList);
    }
  };

  const receivedQtyOnClick = (e, val, rowdata) => {
    if (val != 0) loadReceivedQtyPage(rowdata);
  };
  const shippedQtyOnClick = (e, val, rowdata) => {
    if (val != 0) loadShippedQtyPage(rowdata);
  };
  const adjustedQtyOnClick = (e, val, rowdata) => {
    if (val != 0) loadAdjustedQtyPage(rowdata);
  };
  const receivedInventoryQtyOnClick = (e, val, rowdata) => {
    if (val != 0) {
      loadInventoryQtyPage(rowdata);
    }
  };
  const shippedInventoryQtyOnClick = (e, val, rowdata) => {
    if (val != 0) {
      loadInventoryQtyPage(rowdata);
    }
  };
  const adjustedInventoryQtyOnClick = (e, val, rowdata) => {
    if (val != 0) loadInventoryQtyPage(rowdata);
  };

  const viewFabricModule = (e, val, rowData) => {
    //
  };
  const viewModule = (e, val, rowData) => {
    //
  };
  const Columns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails("Date", "createdDate", true)
        .setStyleDetails("left", "5", "", "wt-4", "wt-4")
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Item", "fabricStyleCode", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)

        .setStyleDetails("left", "12", "", "wt-4", "wt-4")
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Warehouse#", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("OpeningBal", "openingBalance", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("ReceivedQty", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, receivedQtyOnClick, null)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("ShippedQty", "shippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, shippedQtyOnClick, null)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("AdjustQty", "adjustedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, adjustedQtyOnClick, null)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("ClosingBal", "closingBalance", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    // _columns.push(
    //   new ColumnDefinition()
    //     .setDetails("Process", "entityCode", true)
    //     .setStyleDetails("left", "", "", "wt-6", "wt-6")
    //     .setSpecialDetails(true, "entityType", entityClickHanlder)
    // );

    return _columns;
  };

  const receivedQtyLvl1Columns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("Item#", "fabricStyleCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
      // .setClickDetails(true, false, viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Item Name", "fabricStyleName", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-3")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Entity#", "updateEntityCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
      // .setClickDetails(true, false, viewModule, null)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("EntityName", "updateProcess", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SKU#", "skuNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Quantity", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, receivedInventoryQtyOnClick, null)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Container#", "trackNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("WH PO#", "warehousePurchaseOrderNmber", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );

    return columns;
  };

  const receivedQtyLvl2Columns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("Item#", "fabricStyleCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
      // .setClickDetails(true, false, viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Item Name", "fabricStyleName", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-3")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Inventory#", "rollSkuNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Roll", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Lot", "vendorBatchNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SKU#", "skuNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Container#", "containerNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("WH PO#", "warehousePurchaseOrderNmber", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );

    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Quantity", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("IMEI", "imeiNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    return columns;
  };

  const adjustQtyLvl1Columns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("Item#", "fabricStyleCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
      // .setClickDetails(true, false, viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Item Name", "fabricStyleName", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-3")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Entity#", "updateEntityCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
      // .setClickDetails(true, false, viewModule, null)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("EntityName", "updateEntityType", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SKU#", "skuNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Quantity", "adjustedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, adjustedInventoryQtyOnClick, null)
    );

    return columns;
  };

  const adjustQtyLvl2Columns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("Item#", "fabricStyleCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
      // .setClickDetails(true, false, viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Item Name", "fabricStyleName", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-3")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Inventory#", "rollSkuNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Roll", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Lot", "vendorBatchNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SKU#", "skuNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Container#", "containerNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("WH PO#", "warehousePurchaseOrderNmber", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );

    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Quantity", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("IMEI", "imeiNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    return columns;
  };

  const shippedQtyLvl1Columns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("Item#", "fabricStyleCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
      // .setClickDetails(true, false, viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Item Name", "fabricStyleName", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-3")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Entity#", "updateEntityCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
      // .setClickDetails(true, false, viewModule, null)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("EntityName", "updateProcess", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SKU#", "skuNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Quantity", "shippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, shippedInventoryQtyOnClick, null)
    );

    return columns;
  };

  const shippedQtyLvl2Columns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("Item#", "fabricStyleCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
      // .setClickDetails(true, false, viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Item Name", "fabricStyleName", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-3")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Inventory#", "rollSkuNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Roll", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Lot", "vendorBatchNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SKU#", "skuNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Container#", "containerNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("WH PO#", "warehousePurchaseOrderNmber", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );

    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Quantity", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("IMEI", "imeiNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    return columns;
  };

  return (
    <>
      {isLoading ? <Loader /> : null}
      {/****************************** Received Qty Popup Lvl1 **********************************/}
      <Modal
        isOpen={isShowReceivedQtyModalLvl1}
        onClose={closeModal}
        title={"Received Detail"}
        cstmClassName="modal_content_width_70"
      >
        {!isEmpty(receivedQtyList) && receivedQtyList.length != 0 ? (
          <div className="div_cstm_ht">
            <CustomTable
              columns={receivedQtyLvl1Columns()}
              data={receivedQtyList}
              isShowFullScreen={true}
            />
          </div>
        ) : (
          <div className="no_Data">{"NO DATA"}</div>
        )}
      </Modal>

      {/****************************** Received Qty Popup Lvl2 **********************************/}
      <Modal
        isOpen={isShowReceivedQtyModalLvl2}
        onClose={closeModalLvl2}
        title={"Received Inventory Detail"}
        cstmClassName="modal_content_width_70"
      >
        {!isEmpty(receivedInventoryQtyList) &&
        receivedInventoryQtyList.length != 0 ? (
          <div className="div_cstm_ht">
            <CustomTable
              columns={receivedQtyLvl2Columns()}
              data={receivedInventoryQtyList}
              isShowFullScreen={true}
            />
          </div>
        ) : (
          <div className="no_Data">{"NO DATA"}</div>
        )}
      </Modal>

      {/****************************** Shipped Qty Popup Lvl1 **********************************/}
      <Modal
        isOpen={isShowShippedQtyModalLvl1}
        onClose={closeModal}
        title={"Shipped Detail"}
        cstmClassName="modal_content_width_70"
      >
        {!isEmpty(shippedQtyList) && shippedQtyList.length != 0 ? (
          <div className="div_cstm_ht">
            <CustomTable
              columns={shippedQtyLvl1Columns()}
              data={shippedQtyList}
              isShowFullScreen={true}
            />
          </div>
        ) : (
          <div className="no_Data">{"NO DATA"}</div>
        )}
      </Modal>

      {/****************************** Shipped Qty Popup Lvl2 **********************************/}
      <Modal
        isOpen={isShowShippedQtyModalLvl2}
        onClose={closeModalLvl2}
        title={"Shipped Inventory Detail"}
        cstmClassName="modal_content_width_70"
      >
        {!isEmpty(shippedInventoryQtyList) &&
        shippedInventoryQtyList.length != 0 ? (
          <div className="div_cstm_ht">
            <CustomTable
              columns={shippedQtyLvl2Columns()}
              data={shippedInventoryQtyList}
              isShowFullScreen={true}
            />
          </div>
        ) : (
          <div className="no_Data">{"NO DATA"}</div>
        )}
      </Modal>

      {/****************************** Adjust Qty Popup Lvl1 **********************************/}
      <Modal
        isOpen={isShowAdjustedQtyModalLvl1}
        onClose={closeModal}
        title={"Adjusted Detail"}
        cstmClassName="modal_content_width_70"
      >
        {!isEmpty(adjustedQtyList) && adjustedQtyList.length != 0 ? (
          <div className="div_cstm_ht">
            <CustomTable
              columns={adjustQtyLvl1Columns()}
              data={adjustedQtyList}
              isShowFullScreen={true}
            />
          </div>
        ) : (
          <div className="no_Data">{"NO DATA"}</div>
        )}
      </Modal>

      {/****************************** Adjust Qty Popup Lvl2 **********************************/}
      <Modal
        isOpen={isShowAdjustedQtyModalLvl2}
        onClose={closeModalLvl2}
        title={"Adjusted Inventory Detail"}
        cstmClassName="modal_content_width_70"
      >
        {!isEmpty(adjustedInventoryQtyList) && adjustedQtyList.length != 0 ? (
          <div className="div_cstm_ht">
            <CustomTable
              columns={adjustQtyLvl2Columns()}
              data={adjustedInventoryQtyList}
              isShowFullScreen={true}
            />
          </div>
        ) : (
          <div className="no_Data">{"NO DATA"}</div>
        )}
      </Modal>

      {!isEmpty(entityData) ? (
        <Modal
          isOpen={isShowEntityModal}
          onClose={closeModal}
          title={entityData.entityType}
          cstmClassName="modal_content_width_70"
        >
          <div className="div_cstm_ht"></div>
        </Modal>
      ) : null}

      <ToolBar
        title={title}
        // PDFHandler={PDFHandler}
        // ExcelHandler={ExcelHandler}
        ResetHandler={ResetHandler}
        ExecuteHandler={ExecuteHandler}
        // isShowPdf={isShowPdf}
        // isShowExcel={isShowExcel}
      />

      <div className="card-body">
        <div className="row">
          <div className="form-group col-5">
            <Date_Picker
              label={"FromDate"}
              value={criteria.fromDate}
              required={true}
              name="fromDate"
              onChange={dateOnChange}
              disable={disable}
              inputRef={inputRef}
            />
          </div>

          <div className="form-group col-5">
            <Date_Picker
              label={"ToDate"}
              value={criteria.toDate}
              required={true}
              name="toDate"
              onChange={dateOnChange}
              disable={disable}
            />
          </div>
          <div className="form-group col-5">
            <InputTextBox
              suggestions={suggestions}
              value={criteria.fabricStyleCode}
              onChange={onChange}
              label={"ItemCode"}
              name="fabricStyleCode"
              clickHandler={(e) => clickHandler(e)}
              disable={disable}
              enterKeyHandler={enterKeyHandler}
              required={true}
            />
          </div>

          <div className="form-group col-fit">
            <CustomButton
              buttonHandler={buttonHandler}
              disable={disable}
              buttonRef={buttonRef}
              label={"Fetch"}
            />
          </div>
        </div>
      </div>
      {/* {!isEmptyArray(inventoryList) ? (
        <PageBar
          loadFirst={loadFirst}
          loadNext={loadNext}
          loadPrevious={loadPrevious}
          loadLast={loadLast}
          page={page}
        />
      ) : null} */}
      {!isEmptyArray(inventoryList) ? (
        <ViewToggle
          listViewHandler={listViewHandler}
          gridViewHandler={gridViewHandler}
        />
      ) : null}

      {!isEmptyArray(inventoryList) ? (
        <div className="card-body">
          <div className="card-title">
            <h1>Daily Inventory Track Details</h1>
          </div>
          <div className="list-wrap">
            {view === 2 ? (
              <>
                {" "}
                <CustomTable
                  columns={Columns}
                  data={inventoryList}
                  isShowFullScreen={true}
                  isEnableSpan={true}
                />
              </>
            ) : (
              <>
                {inventoryList.map((roll, idx) => {
                  return (
                    <div className="list-itm" key={idx}>
                      <div className="">
                        <span className="_imp">{roll.fabricStyleCode}</span>
                      </div>

                      <div className="">
                        <span className="_imp">{roll.fabricStyleName}</span>
                      </div>

                      <div className="">
                        <span className="_imp">
                          {roll.fabricStyleColorCode}
                        </span>
                      </div>

                      <div className="tb-flex">
                        <div>ReceivedQty</div>
                        <div
                          className="hyperLink"
                          onClick={(e) =>
                            receivedQtyOnClick(e, roll.receivedQuantity, roll)
                          }
                        >
                          ({" "}
                          <span className="_imp">
                            {toCommaSeperatedAmount(roll.receivedQuantity)}
                          </span>{" "}
                          )
                        </div>
                      </div>
                      <div className="tb-flex">
                        <div>ShippedQty</div>
                        <div
                          className="hyperLink"
                          onClick={(e) =>
                            shippedQtyOnClick(e, roll.shippedQuantity, roll)
                          }
                        >
                          ({" "}
                          <span className="_imp">
                            {toCommaSeperatedAmount(roll.shippedQuantity)}
                          </span>{" "}
                          )
                        </div>
                      </div>
                      <div className="tb-flex">
                        <div>AdjustQty</div>
                        <div
                          className="hyperLink"
                          onClick={(e) =>
                            adjustedQtyOnClick(e, roll.adjustedQuantity, roll)
                          }
                        >
                          ({" "}
                          <span className="_imp">
                            {toCommaSeperatedAmount(roll.adjustedQuantity)}
                          </span>{" "}
                          )
                        </div>
                      </div>

                      <div className="tb-flex">
                        <div className="sub-tb-flex">
                          <div>Warehouse</div>
                        </div>
                        <div className="sub-tb-flex">
                          <div>{roll.locationCode}</div>
                        </div>
                      </div>
                      <div className="tb-flex">
                        <div className="sub-tb-flex">
                          <div>Date</div>
                        </div>
                        <div className="sub-tb-flex">
                          <div>{roll.createdDate}</div>
                        </div>
                      </div>

                      <hr />
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </div>
      ) : null}
      <InValidAccess isShow={isAccessible} clickHandler={onClose} />
    </>
  );
}
